import TalkFooter from "./TalkFooter";
export default TalkFooter;
